import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import AccountListPageUI from './AccountListPageUI.js'

class AccountListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: null,
      accountList: null,
    }
  }

  render() {
    return (
      <AccountListPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        accountList={this.state.accountList}
        onRefreshClick={this.onRefreshClick}
        onConnectionUpdate={this.onConnectionUpdate}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getConnectedAccounts(context)
    this.getMessages(context)
  }

  getConnectedAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/user/accounts`,
      cacheKey: CacheKeys.Accounts(context.session.userId),
      callback: this.getConnectedAccountsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getConnectedAccountsCallback = (response) => {
    this.setState({errorList: response.errorList, accountList : response.connectedAccountList})
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.Accounts(this.props.context.session.userId))
    this.setState({accountList: null})
    this.getConnectedAccounts(this.props.context)
  }

  onConnectionUpdate = (connectedAccount) => {
    var index = this.state.accountList.findIndex(account => account.accountId === connectedAccount.accountId)
    console.log(index)
    let accountList = this.state.accountList
    accountList[index] = connectedAccount;
    this.setState({accountList: accountList})
    CacheManager.removeObject(CacheKeys.Accounts(this.props.context.session.userId))
  }

  getMessages(context) {
    let arr = [
      'c_connected_accounts',
      'c_active',
      'c_inactive',
      'c_invited',
      'c_connected',
      'c_disconnected',
      'c_disconnect_account',
      'c_reconnect_account',
      'c_accept_invite',
      'c_decline_invite',
      'c_create_account',
      'c_current',
      'c_switch_to_account',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_conn_acc', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default AccountListPageSF
